import {useInfiniteQuery} from '@tanstack/react-query';
import {AdditionalElementsPageResponse, OntologyTreeElementId} from '../interface';
import {apiClient} from '../../../../../utils/api-client';

interface Props {
    parentId: OntologyTreeElementId;
    ignoreElementIds: OntologyTreeElementId[];
    isCurrentDocOnly: boolean;
    elementsNum: number;
    prioritizedAccession: string;
}

const PAGE_SIZE = 10;

export function useAdditionalChildrenQuery(props: Props) {
    return useInfiniteQuery<AdditionalElementsPageResponse>({
        queryKey: [
            'ontology-tree-additional-children',
            props.parentId,
            props.ignoreElementIds,
            props.prioritizedAccession,
            props.isCurrentDocOnly.toString()
        ],
        queryFn: (context) => {
            const pageParam = context.pageParam as PageParams;
            return apiClient.post({
                path: 'editor-documents-service/api/trees/children',
                parameters: {
                    parentId: props.parentId,
                    limit: pageParam.limit,
                    cursor: pageParam.cursor,
                    includeExternal: !props.isCurrentDocOnly,
                    ignoreElementIds: props.ignoreElementIds,
                    prioritizedAccession: props.prioritizedAccession
                }
            });
        },
        getNextPageParam: ({remaining, nextCursor}) => {
            const hasNextPage = remaining > 0;

            if (hasNextPage) {
                return {
                    cursor: nextCursor,
                    limit: remaining > PAGE_SIZE ? PAGE_SIZE : remaining
                };
            }
        },
        initialPageParam: {
            cursor: null,
            limit: props.elementsNum > PAGE_SIZE ? PAGE_SIZE : props.elementsNum
        } as PageParams,
        enabled: false
    });
}
